// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'

import Title from '../Title/'

import './index.css'

export default class FieldsetPage extends Component {
  renderLeftFieldset () {
    return (
      <div className='left-fieldset'>
        <fieldset>
          <legend>{this.props.leftFieldsetLegend}</legend>
          {this.props.leftFieldsetContent}
        </fieldset>
      </div>
    )
  }

  renderRightFieldset () {
    return (
      <div className='right-fieldset'>
        <fieldset>
          <legend>{this.props.rightFieldsetLegend}</legend>
          {this.props.rightFieldsetContent}
        </fieldset>
      </div>
    )
  }

  render () {
    return (
      <div className='fieldset-page'>
        <div className='container-fluid align-items-center'>
          <Title>
            {this.props.title}
          </Title>
          <div className='row'>
            <div className={this.props.leftFieldsetClassName || 'col-12 col-md-6'}>
              {this.renderLeftFieldset()}
            </div>
            <div className={this.props.rightFieldsetClassName || 'col-12 col-md-6'}>
              {this.renderRightFieldset()}
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12'>
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
